import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import { Info, Document } from '../../assets/icons';
import './PropertyOffering.scss';
import { offeringData } from '../../pages/PropertyListing/IOVacationData';
import { useSelector } from 'react-redux';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal} from '../../utils/usCurrencyFormatter';
import { singleOfferingData } from '../../pages/PropertyListing/IOSingleData';
import { PROPERTY_SUB_TYPE, TOOLTIP_TEXT } from '../../utils/constant';

const PropertyOffering = (props) => {
  const { data } = useSelector((state) => state.propertyDetails);
  const currentOfferingData =
    data?.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE.VACATION?.toLowerCase() ? offeringData : singleOfferingData;
  const detailsData = useMemo(() => {
    let value = '';
    return Object.keys(data?.data || {})?.length
      ? currentOfferingData.details.map((x) => {
          switch (x.value) {
            case 'mortgageAmount':
              value = getUsCurrencyFormat(Number(data?.data?.finance?.mortgageAmount || 0));
              break;
            case 'mortgageInterestRate':
              value = getUsCurrencyFormat(Number(data?.data?.finance?.mortgageInterestRate || 0));
              break;
            case 'equityRaised':
              value = getUsCurrencyFormat(Number(data?.data?.finance?.equityRaised || 0));
              break;
            case 'perSharePrice':
              value = getUsCurrencyFormat(Number(data?.data?.finance?.perSharePrice || 0));
              break;
            case 'totalShare':
              value = getUsCurrencyFormatWithoutDecimal(Number(data?.data?.totalShare || 0));
              break;
            case 'leverage':
              value = getUsCurrencyFormat(Number(data?.data?.finance?.leverage || 0));
              break;
            default:
              break;
          }
          if (x.suffix && !value.endsWith(x.suffix)) {
            value = `${value}${x.suffix}`;
          }
          if (x.prefix && !value.startsWith(x.prefix)) {
            value = `${x.prefix}${value}`;
          }
          return { ...x, value };
        })
      : [];
  }, [data?.data]);

  const expensesData = useMemo(() => {
    let amount = '';
    return Object.keys(data?.data || {})?.length
      ? currentOfferingData.expanses.map((x) => {
          switch (x.amount) {
            case 'purchasePrice':
              amount = getUsCurrencyFormat(Number(data?.data?.finance?.purchasePrice || 0));
              break;
            case 'improvements':
              amount = getUsCurrencyFormat(Number(data?.data?.finance?.improvements || 0));
              break;
            case 'cohCosts':
              amount = getUsCurrencyFormat(Number(data?.data?.finance?.cohCosts || 0));
              break;
            case 'sourcingFees':
              amount = getUsCurrencyFormat(Number(data?.data?.finance?.sourcingFees || 0));
              break;
            default:
              break;
          }
          if (x.suffix && !amount.endsWith(x.suffix)) {
            amount = `${amount}${x.suffix}`;
          }
          if (x.prefix && !amount.startsWith(x.prefix)) {
            amount = `${x.prefix}${amount}`;
          }
          return { ...x, amount };
        })
      : [];
  }, [data?.data]);

  const feesData = useMemo(() => {
    let amount = '';
    return Object.keys(data?.data || {}).length
      ? currentOfferingData.fees.map((x) => {
          switch (x.amount) {
            case 'aumFees':
              amount = getUsCurrencyFormat(Number(data?.data?.finance?.aumFees || 0));
              break;
            default:
              break;
          }
          if (x.suffix && !amount.endsWith(x.suffix)) {
            amount = `${amount}${x.suffix}`;
          }
          if (x.prefix && !amount.startsWith(x.prefix)) {
            amount = `${x.prefix}${amount}`;
          }
          if (x.amount) {
            return { ...x, amount };
          }
          return { ...x };
        })
      : [];
  }, [data?.data]);

  const renderFees = (point) => {
    const [key, value] = Object.entries(point || {})?.[0];
    if (key === 'min_max') {
      return value(
        `${getUsCurrencyFormat(Number(data?.data?.finance?.['propertyMgmtFeesMin']) || 0)}%`,
        `${getUsCurrencyFormat(Number(data?.data?.finance?.['propertyMgmtFeesMax']) || 0)}%`
      );
    }
    return value(`${getUsCurrencyFormat(Number(data?.data?.finance?.[key]) || 0)}%`);
  };

  return (
    <div className='py-64 property-offering'>
      <p className='mb-32 fz-24 fw-700 lh-13'>Offering details</p>
      <div className='mb-32 details'>
        {detailsData.map((data, index) => {
          return (
            <div className='details__item' key={index}>
              <Tooltip title={data.tooltip}>
                <span className={!!data.tooltip ? 'details__item__label tooltip' : 'details__item__label'}>
                  {data.label}{' '}
                  {data.tooltip && (
                    <span>
                      <Info marginLeft='8px' verticalAlign='sub' />
                    </span>
                  )}
                </span>
              </Tooltip>
              <span className='details__item__value'>{data.value}</span>
            </div>
          );
        })}
      </div>
      {/* <p className='fz-18 fw-600'>Property Volatility</p>
      <p className='fz-16'>
        Higher leveraged properties have a bigger potential for returns... this text should be more about what leverage actually is and how it affects
        your investment.
      </p>
      <div className='risk'>
        <div className='risk__graph'>
          <img src={Images.riskGraph} alt='' />
        </div>
        <hr className='hr' />
        <div className='risk__grade'>
          <p className='fw-600 fz-16'>Risk aversion rating</p>
          <p className='risk__grade__rating'>{props.rating}</p>
          <p className='fz-12 mb-0'>
            Lorem ipsum dolor sit amet consectetur. Lectus ultrices vel bibendum at ipsum. Arcu eget iaculis suspendisse volutpat.{' '}
            <a href='/not-found/' className='text-terracotta underline'>
              Learn more
            </a>
          </p>
        </div>
      </div> */}
      <div className='expanses'>
        <p className='fz-18 fw-600 mt-40'>Offering Expenses</p>
        <div className='expanses__list'>
          {expensesData.map((data, index) => {
            return (
              <div className='expanses__list__item' key={index}>
                <Tooltip title={data.tooltip}>
                  <span className={!!data.tooltip ? 'expanses__list__item__label tooltip' : 'expanses__list__item__label'}>
                    {data.label}{' '}
                    {data.tooltip && (
                      <span>
                        <Info marginLeft='8px' verticalAlign='sub' />
                      </span>
                    )}
                  </span>
                </Tooltip>
                <span className='expanses__list__item__value'>{data.amount}</span>
              </div>
            );
          })}
          <div className='expanses__list__item'>
            <span className='expanses__list__item__label'>Total property cost</span>
            <span className='fw-600 expanses__list__item__value'>${getUsCurrencyFormat(Number(data?.data?.finance?.totalCost || 0))}</span>
          </div>
        </div>
      </div>
      <div className='fees'>
        <p className='fz-18 fw-600 mt-40'>Recurring Fees</p>
        <div className='fees__list'>
          {feesData.map((data, index) => {
            return (
              <div className='fees__list__item item' key={index}>
                <div className='amount-value'>
                  <Tooltip title={data.tooltip}>
                    <span className='item__name'>
                      {data.name} <Info marginLeft='8px' verticalAlign='sub' />
                    </span>
                  </Tooltip>
                  {/* {!!data.amount && <p className='mb-0 fw-600 item__amount'>{data.amount}</p>} */}
                </div>
                <ul className='item__points'>
                  {data.points.map((point, index) => {
                    if (typeof point === 'string') {
                      return (
                        <li className='item__points__item' key={index}>
                          {point}
                        </li>
                      );
                    }
                    return (
                      <li className='item__points__item' key={index}>
                        {renderFees(point)}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
          <div className='fees__list__item item text-taupe-60'>
          {TOOLTIP_TEXT.RECURRING_FEE_NOTE}
          </div>
        </div>
      </div>
      <div className='documents'>
        <p className='fz-18 fw-600 mt-40'>Documents</p>
        <div className='documents__list'>
          {data?.data?.documents?.length
            ? data?.data?.documents.map((doc, index) => {
                return (
                  <div className='document' key={index}>
                    <Document marginRight='12px' className='document__icon' />
                    <span className='document__name'>{doc.name}</span>
                    <a href={doc.url} className='document__link' target={'_blank'} rel='noreferrer'>
                      View
                    </a>
                  </div>
                );
              })
            : 'No Documents'}
        </div>
      </div>
    </div>
  );
};

export default PropertyOffering;
